import { render } from "./Popup.vue?vue&type=template&id=15d7ee2e&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=15d7ee2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15d7ee2e"

export default script